import {FooterType} from "../app/FooterType";
import {PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {SelectItem} from "@pledger/frontend-commons/dist/ui/components/dropDown/CustomSelectComponent";
import {SuiviVentesActions} from "./SuiviVentesActions";
import {
    loanRequestStatusesWServiceActions
} from "../../services/ws/LoanRequestStatuses/loanRequestStatusesWServiceActions";
import {
    getSimulationSaleStatusCodeDescription,
    SimulationSaleStatusCode,
    SimulationSaleStatusJSON
} from "../../services/ws/LoanRequestStatuses/dto/SellingSouscriptionsResponseJSON";


const R = require('ramda');

const footerType = (state = FooterType.NONE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.NONE;
    }
};

const pageLoaded = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case loanRequestStatusesWServiceActions.GET_SELLING_SOUSCRIPTIONS_SUCCEEDED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const salesSouscriptionList = (state : SimulationSaleStatusJSON[] = [], action : PledgerAction) => {
    switch (action.type) {
        case loanRequestStatusesWServiceActions.GET_SELLING_SOUSCRIPTIONS_SUCCEEDED_ACTION.type: {
           // const lenderSouscriptions = Array.from({length: 100}).fill(action.payload.data.saleStatusItems[0]); // remplir avec des données de test
            const lenderSouscriptions = action.payload.data.saleStatusItems;
            return lenderSouscriptions;
        }


        default:
            return state;
    }
};

function filterSouscriptionList(salesSouscriptionList : SimulationSaleStatusJSON[],searchFilter:string,statusFilter : string) : SimulationSaleStatusJSON[] {

    const actualFilter = searchFilter.trim().toLowerCase();

    let souscriptionList : SimulationSaleStatusJSON[];
    if (actualFilter.length>0) {
        souscriptionList=salesSouscriptionList.filter(souscriptionDetails => {
            if (souscriptionDetails.firstName!==undefined && souscriptionDetails.firstName.toLowerCase().indexOf(actualFilter)>=0) {
                return true;
            }
            if (souscriptionDetails.lastName!==undefined && souscriptionDetails.lastName.toLowerCase().indexOf(actualFilter)>=0) {
                return true;
            }
            if (souscriptionDetails.loanContractNumber!==undefined && souscriptionDetails.loanContractNumber.toLowerCase().indexOf(actualFilter)>=0) {
                return true;
            }
          return false;
        });
    }
    else {
        souscriptionList=salesSouscriptionList;
    }

    const filteredData = souscriptionList.filter(souscriptionDetails => {
        if (statusFilter!=='' && souscriptionDetails.status!==statusFilter) {
            return false;
        }
        return true;
    })
    return filteredData;
}

const pageItemSize = () => {
    const innerHeight = window.innerHeight;
    return Math.floor((innerHeight-280) / 53);
}

const currentSouscriptionPage = (state : number = 0,action : PledgerAction)=> {

    switch (action.type) {
        case SuiviVentesActions.SET_SOUSCRIPTION_CURRENT_PAGE.type:
            return action.payload.currentPage;

        case loanRequestStatusesWServiceActions.GET_SELLING_SOUSCRIPTIONS_SUCCEEDED_ACTION.type:
            return 0;

        case SuiviVentesActions.APPLY_SEARCH_FILTER_ACTION.type:
            return 0;
    }
    return state;
};

const pageSize = (state : number = 0,action : PledgerAction)=> {
    switch (action.type) {
        case loanRequestStatusesWServiceActions.GET_SELLING_SOUSCRIPTIONS_SUCCEEDED_ACTION.type: {
            return pageItemSize();
        }
    }
     return state;
};

const filteredSalesSouscriptionList = (state : SimulationSaleStatusJSON[][] = [[]], action : PledgerAction) => {
    switch (action.type) {

        case SuiviVentesActions.APPLY_SEARCH_FILTER_ACTION.type: {
            const suiviVenteState: SuiviVentesPageComponentState = action.payload.suiviVenteState;
            const searchFilter = action.payload.searchFilter;
            const lenderSouscriptionList = suiviVenteState.salesSouscriptionList;
            const statusFilter = suiviVenteState.statusFilter;
            const filtered = filterSouscriptionList(lenderSouscriptionList, searchFilter, statusFilter);
            if (filtered.length===0) {
                return [[]];
            }
            return R.splitEvery(pageItemSize(), filtered);
        }

        case loanRequestStatusesWServiceActions.GET_SELLING_SOUSCRIPTIONS_SUCCEEDED_ACTION.type: {
            const pageSize = pageItemSize();
            // remplir avec des données de test
           //  const lenderSouscriptions = Array.from({length: 100}).fill(action.payload.data.saleStatusItems[0]);
            const lenderSouscriptions = action.payload.data.saleStatusItems;
            if (lenderSouscriptions.length===0) {
                return [[]];
            }return R.splitEvery(pageSize, lenderSouscriptions);
        }


        case SuiviVentesActions.SELECT_STATUS_FILTER_ACTION.type: {
            const suiviVenteState: SuiviVentesPageComponentState = action.payload.suiviVenteState;
            const lenderSouscriptionList = suiviVenteState.salesSouscriptionList;

            let statusFilter: string;
            if (action.payload.filter === 'NONE') {
                statusFilter = '';
            } else {
                statusFilter = action.payload.filter;
            }
            const filtered = filterSouscriptionList(lenderSouscriptionList, suiviVenteState.searchFilter,statusFilter);
            if (filtered.length===0) {
                return [[]];
            }return R.splitEvery(pageItemSize(),filtered);
        }


        default:
            return state;
    }
};


const statusFilterList = (state:SelectItem[] = [], action : PledgerAction) => {
    switch (action.type) {
        case loanRequestStatusesWServiceActions.GET_SELLING_SOUSCRIPTIONS_SUCCEEDED_ACTION.type:
            const salesSouscriptions : SimulationSaleStatusJSON[] = action.payload.data.saleStatusItems;
            const currentValues = new Set<SimulationSaleStatusCode>();
            salesSouscriptions.forEach(lenderSouscription => currentValues.add(lenderSouscription.status!));
            const filterList= Array.from(currentValues).map(currentValue => {
                const label = getSimulationSaleStatusCodeDescription(currentValue);
                return {code:currentValue,label:label};
            }).filter(value => value.label!==undefined);
            if (filterList.length>0) {
                return [{code: 'NONE', label: 'Tous'}, ...filterList];
            }
            else {
                return filterList;
            }
        default:
            return state;
    }
};

const statusFilter = (state:string = '', action : PledgerAction) => {
    switch (action.type) {
        case SuiviVentesActions.SELECT_STATUS_FILTER_ACTION.type:
            if (action.payload.filter==='NONE') {
                return '';
            }
            else {
                return action.payload.filter;
            }
        default:
            return state;
    }
};


const searchFilter = (state:string = '', action : PledgerAction) => {
    switch (action.type) {
        case loanRequestStatusesWServiceActions.GET_SELLING_SOUSCRIPTIONS_SUCCEEDED_ACTION.type:
            return '';

        case SuiviVentesActions.CHANGE_SEARCH_FILTER_ACTION.type:
            return action.payload.searchFilter.trim();

        default:
            return state;
    }
};


export interface SuiviVentesPageComponentState extends PledgerPageComponentState {
    pageLoaded: boolean;
    salesSouscriptionList: SimulationSaleStatusJSON[];
    filteredSalesSouscriptionList: SimulationSaleStatusJSON[][];
    currentSouscriptionPage : number;
    pageSize : number;
    statusFilterList:SelectItem[];
    statusFilter:string;
    searchFilter:string;
}

const navigationMenuEnabled = (state = true, action : PledgerAction) => {
    switch (action.type) {
        default:
            return true;
    }
};

export const suiviVentes : Reducer = (state={}, action)=> {
    return {
        footerType: footerType(state.footerType, action),
        pageLoaded: pageLoaded(state.pageLoaded, action),
        salesSouscriptionList: salesSouscriptionList(state.salesSouscriptionList, action),
        filteredSalesSouscriptionList: filteredSalesSouscriptionList(state.filteredSalesSouscriptionList, action),
        currentSouscriptionPage: currentSouscriptionPage(state.currentSouscriptionPage, action),
        pageSize: pageSize(state.pageSize, action),
        statusFilterList: statusFilterList(state.statusFilterList, action),
        statusFilter: statusFilter(state.statusFilter, action),
        searchFilter: searchFilter(state.searchFilter, action),
        navigationMenuEnabled: navigationMenuEnabled(state.navigationMenuEnabled, action),
    }
}
